export enum ChecklistStatus {
  Incomplete = 'INCOMPLETE',
  Complete = 'COMPLETE',
}
